export default {
  'FORM' (state) {
    return state.form
  },
  'FORMS' (state) {
    return state.forms
  }
}
